import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ListStore } from '../store';
import LoadingMore from '../../../components/LoadingMore';
import Link, { linkBase } from '@src/mobile/components/Link';
import iconFanzhuan from '../../assets/fanzhuan.png';
import iconShichui from '../../assets/shichui.png';
import { formatNodeTime, formatPeopleCount } from '@src/public/utils/format';
import { getUpdates } from '../service';

const Latest = () => {
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { page, size, nodes } = listStates;

    const control = async () => {
        try {
            const res = await getUpdates(page, size);
            const { pagination, list } = res;
            const { total } = pagination;
            let statusText = '';

            if (page * size >= total) {
                statusText = 'end';
            } else {
                statusText = 'success';
            }

            changeListStates({ total, page: page + 1, nodes: [...nodes, ...list] });

            return statusText;
        } catch (e) {
            console.error(e);

            return 'error';
        }
    };

    const getMilestone = id => {
        switch (id) {
            case 1:
                return <img src={iconFanzhuan} alt="" className={styles.milestone} />;
            case 2:
                return <img src={iconShichui} alt="" className={styles.milestone} />;
            default:
                return null;
        }
    };

    return (
        <div className={styles.wrap}>
            <div className={styles.title}>最新进展</div>
            <div className={styles.list}>
                {nodes.map(item => {
                    const { nodeId, timelineId, title, updateTime, milestone, interaction } = item;
                    const { comment } = interaction;

                    return (
                        <div className={styles.item} key={`${timelineId}_${nodeId}`}>
                            <Link
                                to={`${linkBase}/loc/timeline/event/${timelineId}?msgSubjectId=${nodeId}&ref=timeline_merge`}
                                className={styles.itemLink}>
                                <div className={styles.itemTitle}>
                                    {getMilestone(milestone)}
                                    <span className={styles.itemTitleText}>{title}</span>
                                </div>
                                <div className={styles.info}>
                                    <div className={styles.time}>{formatNodeTime(updateTime)}</div>
                                    {comment >= 20 ? (
                                        <div className={styles.comment}>{formatPeopleCount(comment)}人参与讨论</div>
                                    ) : null}
                                </div>
                            </Link>
                        </div>
                    );
                })}
            </div>
            <LoadingMore control={control} />
        </div>
    );
};

export default errorBoundary(Latest);
